module.exports = ".dark-modal .modal-content {\n  background-color: #292b2c;\n  color: white; }\n\n.dark-modal .close {\n  color: white; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/sidebar/sidebar.component.scss
// module id = ./src/app/shared/sidebar/sidebar.component.scss
// module chunks = main